import { render, staticRenderFns } from "./monitor.vue?vue&type=template&id=70a097ac&scoped=true&"
import script from "./monitor.vue?vue&type=script&setup=true&lang=js&"
export * from "./monitor.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./monitor.vue?vue&type=style&index=0&id=70a097ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a097ac",
  null
  
)

export default component.exports